import React from "react";
import { Link, Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import shortid from "shortid";
import "gentelella/build/css/custom.min.css";
import "../../assets/css/login.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import swal from "sweetalert2";
import { login, registerRecordType, redirectToHomepage } from "./actions";
import {
  checkEmail,
  getSalesforceToken,
  updateObject,
  spmfcloudFunctionUrl,
} from "../../actions/salesforces";
import fbLogo from "../../assets/img/fb-white.png";

class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      error: null,
      loading: false,
    };
    this.submit = this.submit.bind(this);
    this.login = login.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.checkEmail = checkEmail.bind(this);
  }

  componentWillMount() {
    document.body.className = "login";
  }

  async componentDidMount() {
    await this.props.getSalesforceToken();
  }

  componentWillUnmount() {
    document.body.className = "nav-md";
  }

  async submit(e) {
    e.preventDefault();
    try {
      this.setState({ error: null, loading: true });
      const result = await this.login(
        this.state.email,
        this.state.password,
        this.props.user.siteToken.hash
      );

      if (window.__DEV__) {
        this.props.redirectToHomepage(result);
      } else {
        const { Id } = result.payload.user;
        const config = {
          method: "POST",
          body: JSON.stringify({
            accountId: Id,
          }),
          mode: "cors",
          cache: "no-cache",
          headers: {
            "hash-token": this.props.user.siteToken.hash,
            "Content-Type": "application/json",
          },
        };
        // Tell the server to send the 2nd factor auth code to user now
        const codeIsSent = await fetch(
          `${spmfcloudFunctionUrl}/send-second-auth`,
          config
        );
        const json = await codeIsSent.json();

        if (!codeIsSent.ok) {
          throw new Error(json.message);
        }

        // Afterwards, display a dialog box to receive the code from user
        const result2 = await swal({
          title: "2nd Factor Authentication",
          html: "Please check your email for the passcode",
          input: "password",
          inputPlaceholder: "Please key in the 2nd factor auth code",
          allowOutsideClick: false,
          showCancelButton: true,
          type: "question",
          preConfirm: async (code) => {
            try {
              swal.showLoading();
              // Compare the code in server
              const codeIsCompared = await fetch(
                `${spmfcloudFunctionUrl}/compare-second-auth`,
                {
                  ...config,
                  body: JSON.stringify({
                    accountId: Id,
                    authCode: code,
                  }),
                }
              );
              const json2 = await codeIsCompared.json();

              if (!codeIsCompared.ok) {
                throw new Error(json2.message);
              }
              this.props.registerRecordType();
              // The code has been authenticated
              // Proceed to the homepage
              this.props.redirectToHomepage(result);
            } catch (error) {
              swal.hideLoading();
              swal.showValidationError(error.message);
              // swal.close();
              this.setState({ loading: false, error: error.message });
              setTimeout(() => this.setState({ error: null }), 5000);
            }
          },
        });

        if (result2.dismiss) {
          this.setState({ loading: false });
        }
      }
    } catch (error) {
      this.setState({ loading: false, error: error.message });
      // setTimeout(() => this.setState({ error: null }), 15000);
    }
  }

  async resetPassword(e) {
    e.preventDefault();
    try {
      const { value: email } = await swal({
        title: "Reset Password",
        input: "email",
        inputPlaceholder: "Please key in your portal login name",
        allowOutsideClick: true,
        type: "question",
      });

      if (email) {
        const { siteToken } = this.props.user;
        this.setState({ loading: true });
        // 1. Check if the email exists
        const apiResult = await fetch(
          `${spmfcloudFunctionUrl}/auth/reset-password`,
          {
            headers: {
              "Content-Type": "application/json",
              "hash-token": siteToken.hash,
            },
            body: JSON.stringify({
              email,
            }),
            method: "post",
          }
        ).then((res) => res.json());

        if (apiResult.status === 200) {
          swal({
            title: "Success",
            type: "success",
            text: "A new password has been sent to email",
            showConfirmButton: true,
            timer: 4000,
          });
        } else {
          swal({
            title: "Failed to reset password",
            type: "error",
            text: apiResult.message,
            showConfirmButton: true,
            timer: 4000,
          });
        }
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false, error: error.message });
      setTimeout(() => this.setState({ error: null }), 5000);
    }
  }

  render() {
    if (this.props.user.loggedInUser !== null) return <Redirect to="portal" />;
    return (
      <div className="">
        <div className="login-page container">
          <div className="row">
            <div className="col-sm-9 hidden-xs">
              <div id="welcome">
                <p>Welcome to SPMF Portal</p>
                <p>
                  Since the Fund started in <span>2000</span>, it has helped
                  over <span>160,000</span> students from low-income families.
                </p>
              </div>
            </div>
            <div className="col-sm-3 col-xs-12">
              <div className="login_wrapperx">
                <div className="animatex formx login_formx spmf-login-form">
                  <section className="login_content spmf-login-content">
                    <img
                      src="https://www.spmf.org.sg/resources/front/template/spmf/images/logo.png"
                      alt="logo"
                      className="logo"
                    />
                    <form onSubmit={this.submit}>
                      <h1>
                        {process.env.SPMF_ENVIRONMENT === "SANDBOX"
                          ? "Sandbox"
                          : ""}{" "}
                        Login Form
                      </h1>
                      <p style={{ textAlign: "center" }}>
                        {this.state.loading ? (
                          <i className="fa fa-2x fa-spinner fa-spin" />
                        ) : null}
                      </p>
                      <div
                        className="alert alert-danger"
                        style={{
                          display: this.state.error === null ? "none" : "block",
                        }}
                      >
                        <p
                          style={{ color: "#000", textAlign: "left" }}
                          dangerouslySetInnerHTML={{ __html: this.state.error }}
                        />
                      </div>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          required
                          onChange={(e) =>
                            this.setState({ email: e.target.value })
                          }
                        />
                      </div>
                      <div>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Password"
                          required
                          onChange={(e) =>
                            this.setState({ password: e.target.value })
                          }
                        />
                      </div>
                      <div>
                        <button
                          className="btn btn-default submit"
                          type="submit"
                        >
                          {process.env.SPMF_ENVIRONMENT === "SANDBOX"
                            ? "Sandbox"
                            : ""}{" "}
                          Login
                        </button>
                      </div>
                      <div id="lost-password">
                        <Link to="/#" onClick={this.resetPassword}>
                          Lost your password?
                        </Link>
                      </div>

                      <div className="clearfix" />

                      <div className="separatorx">
                        {/* <p className="change_link">New to site?
                                                    <a href="#signup" className="to_register"> Create Account </a>
                                                </p>
                                                <div className="clearfix" />
                                                <br /> */}
                        <div>
                          {/* <h1><i className="fa fa-heart" /> STSPMF</h1> */}
                          <p id="copyright">2019 portal.spmf.org.sg</p>
                        </div>
                      </div>
                    </form>
                  </section>
                </div>
              </div>
            </div>
          </div>
          <div className="row links">
            <div className="col-sm-8">
              <div className="row">
                <div className="col-sm-3">
                  <a href="#">Terms and Conditions</a>
                </div>
                <div className="col-sm-3">
                  <a href="#">Privacy Policy</a>
                </div>
                <div className="col-sm-3">
                  <span>&copy; 2019 SPMF.org.sg</span>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="pull-right">
                <img src={fbLogo} />
                &nbsp;
                <a href="https://web.facebook.com/STSPMF/">STSPMF</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  user: PropTypes.object.isRequired,
  salesforce: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  getSalesforceToken: PropTypes.func.isRequired,
  registerRecordType: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // login,
      redirectToHomepage,
      getSalesforceToken,
      registerRecordType,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  user: state.user,
  salesforce: state.salesforce,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



//////////////////
// WEBPACK FOOTER
// ./src/components/Login/index.js
// module id = 281
// module chunks = 0